import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from './assets/logo-horizontal.png';
import _imports_1 from './assets/menu-icon-mobile.png';
import _imports_2 from './assets/close-menu.png';
import _imports_3 from './assets/businessCooperation/qrcode.png';
import _imports_4 from './assets/qrcode.jpeg';
const _hoisted_1 = {
  key: 1,
  class: "header-for-mobile"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo-img",
  src: _imports_0,
  alt: ""
}, null, -1);

const _hoisted_3 = {
  class: "menu-item"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "active-bar"
}, null, -1);

const _hoisted_5 = ["href", "onClick"];

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "active-bar"
}, null, -1);

const _hoisted_7 = ["href", "onClick"];

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "active-bar"
}, null, -1);

const _hoisted_9 = ["href", "onClick"];

const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "active-bar"
}, null, -1);

const _hoisted_11 = ["href", "onClick"];
const _hoisted_12 = {
  key: 0,
  class: "dialog-content"
};

const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "qrcode",
  src: _imports_3,
  alt: "添加客服微信，了解更多信息"
}, null, -1);

const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "添加客服微信，了解更多信息", -1);

const _hoisted_15 = [_hoisted_13, _hoisted_14];
const _hoisted_16 = {
  key: 1,
  class: "dialog-content"
};

const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  class: "qrcode",
  src: _imports_4,
  alt: "关注公众号，了解更多信息"
}, null, -1);

const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "关注公众号，了解更多信息", -1);

const _hoisted_19 = [_hoisted_17, _hoisted_18];
const _hoisted_20 = {
  key: 0,
  class: "dialog-content-mobile"
};

const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  class: "qrcode",
  src: _imports_3,
  alt: "添加客服微信，了解更多信息"
}, null, -1);

const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "添加客服微信，了解更多信息", -1);

const _hoisted_23 = [_hoisted_21, _hoisted_22];
const _hoisted_24 = {
  key: 1,
  class: "dialog-content-mobile"
};

const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  class: "qrcode",
  src: _imports_4,
  alt: "关注公众号，了解更多信息"
}, null, -1);

const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "关注公众号，了解更多信息", -1);

const _hoisted_27 = [_hoisted_25, _hoisted_26];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HeaderForPC = _resolveComponent("HeaderForPC");

  const _component_router_view = _resolveComponent("router-view");

  const _component_FooterForPC = _resolveComponent("FooterForPC");

  const _component_FooterForMobile = _resolveComponent("FooterForMobile");

  const _component_router_link = _resolveComponent("router-link");

  const _component_van_popup = _resolveComponent("van-popup");

  const _component_el_dialog = _resolveComponent("el-dialog");

  const _component_van_dialog = _resolveComponent("van-dialog");

  return _openBlock(), _createElementBlock("div", null, [_ctx.isPc ? (_openBlock(), _createBlock(_component_HeaderForPC, {
    key: 0
  })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("img", {
    class: "menu-icon",
    src: _imports_1,
    onClick: _cache[0] || (_cache[0] = $event => $data.show = true)
  })])), _createVNode(_component_router_view, {
    onEventFromChildRoute: $options.eventFromChildRoute
  }, {
    default: _withCtx(({
      Component,
      route
    }) => [(_openBlock(), _createBlock(_KeepAlive, {
      include: route.meta.keepAlive ? route.name : ''
    }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
      key: route.path
    }))], 1032, ["include"]))]),
    _: 1
  }, 8, ["onEventFromChildRoute"]), _ctx.isPc ? (_openBlock(), _createBlock(_component_FooterForPC, {
    key: 2
  })) : (_openBlock(), _createBlock(_component_FooterForMobile, {
    key: 3
  })), !_ctx.isPc ? (_openBlock(), _createBlock(_component_van_popup, {
    key: 4,
    show: $data.show,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $data.show = $event),
    position: "right",
    style: _normalizeStyle({
      width: '20.7rem',
      height: '100%'
    })
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      src: _imports_2,
      class: "close-icon",
      onClick: _cache[1] || (_cache[1] = $event => $data.show = false)
    }), _createElementVNode("ul", _hoisted_3, [_createVNode(_component_router_link, {
      to: {
        path: '/HomePage'
      },
      custom: "",
      "active-class": "link-active"
    }, {
      default: _withCtx(({
        navigate,
        href,
        isActive,
        isExactActive
      }) => [_createElementVNode("li", {
        class: _normalizeClass([isActive && 'link-active', isExactActive && 'router-link-exact-active', 'link-li'])
      }, [_hoisted_4, _createElementVNode("a", {
        class: "link",
        href: href,
        onClick: $event => $options.jump(navigate)
      }, "如猫天翼", 8, _hoisted_5)], 2)]),
      _: 1
    }), _createVNode(_component_router_link, {
      to: {
        path: '/HotPersonPage'
      },
      custom: "",
      "active-class": "link-active"
    }, {
      default: _withCtx(({
        navigate,
        href,
        isActive,
        isExactActive
      }) => [_createElementVNode("li", {
        class: _normalizeClass([isActive && 'link-active', isExactActive && 'router-link-exact-active', 'link-li'])
      }, [_hoisted_6, _createElementVNode("a", {
        class: "link",
        href: href,
        onClick: $event => $options.jump(navigate)
      }, "如猫天翼达人端", 8, _hoisted_7)], 2)]),
      _: 1
    }), _createVNode(_component_router_link, {
      to: {
        path: '/BusinessCooperationPage'
      },
      custom: "",
      "active-class": "link-active"
    }, {
      default: _withCtx(({
        navigate,
        href,
        isActive,
        isExactActive
      }) => [_createElementVNode("li", {
        class: _normalizeClass([isActive && 'link-active', isExactActive && 'router-link-exact-active', 'link-li'])
      }, [_hoisted_8, _createElementVNode("a", {
        class: "link",
        href: href,
        onClick: $event => $options.jump(navigate)
      }, "业务合作", 8, _hoisted_9)], 2)]),
      _: 1
    }), _createVNode(_component_router_link, {
      to: {
        path: '/JoinUsPage'
      },
      custom: "",
      "active-class": "link-active"
    }, {
      default: _withCtx(({
        navigate,
        href,
        isActive,
        isExactActive
      }) => [_createElementVNode("li", {
        class: _normalizeClass([isActive && 'link-active', isExactActive && 'router-link-exact-active', 'link-li'])
      }, [_hoisted_10, _createElementVNode("a", {
        class: "link",
        href: href,
        onClick: $event => $options.jump(navigate)
      }, "加入我们", 8, _hoisted_11)], 2)]),
      _: 1
    })])]),
    _: 1
  }, 8, ["show", "style"])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.dialogVisible = $event),
    "custom-class": "dialog",
    width: "42.8rem"
  }, {
    default: _withCtx(() => [$data.code === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15)) : $data.code === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_van_dialog, {
    show: $data.dialogVisibleMobile,
    "onUpdate:show": _cache[4] || (_cache[4] = $event => $data.dialogVisibleMobile = $event),
    closeOnClickOverlay: true
  }, {
    default: _withCtx(() => [$data.code === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23)) : $data.code === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_27)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["show"])]);
}